module.exports = __webpack_public_path__ + "static/media/priyanshu.323cc9ec.pdf";